import * as React from 'react';

import type { Sort, Attributes } from 'stores/PaginationTypes';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import RowActionMenu from './row-action-menu';

export const EVENT_PROCEDURES_STEPLIST_ID = 'eventProceduresStepList';

export const ATTRIBUTES: Attributes = [
  {
    id: 'title',
    title: 'Title',
    type: 'STRING',
    sortable: true,
  },
  {
    id: 'description',
    title: 'Description',
    type: 'STRING',
  },
  {
    id: 'type',
    title: 'Action',
    type: 'STRING',
  },
  {
    id: 'collections',
    title: 'Collections',
    type: 'STRING',
  },
];

export const listElements = {
  defaultLayout: {
    entityTableId: EVENT_PROCEDURES_STEPLIST_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: 'title', direction: 'asc' } as Sort,
    defaultDisplayedAttributes: ['title', 'description', 'type', 'collections'],
  },
  columnOrder: ['title', 'description', 'type', 'collections'],
};

export const deserializeEventProceduresSteps = ({ page, per_page, total, count, event_procedure_steps }) => ({
  attributes: ATTRIBUTES,
  list: event_procedure_steps.map((step: EventProcedureStepAPIType) => ({
    ...step,
    type: step?.action?.config?.type,
    collections: 'unauthorized',
  })),
  pagination: { total, page, per_page, count },
});

export const entityActionRender = (step: EventProcedureStepAPIType) => <RowActionMenu eventProcedureStep={step} />;
